import { useAPI, useAsyncHandler } from '~/hooks/common';

import { API_ENDPOINT } from '~/constants';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypePostOrdersUploadParams, TypePostOrdersUploadResponse } from '~/types/delivery-agency.types';

const usePostOrdersUpload = () => {
  const { runAsync } = useAsyncHandler();

  const postOrdersUpload = useAPI<TypePostOrdersUploadParams, TypePostOrdersUploadResponse>({
    endpoint: API_ENDPOINT.DELIVERY_AGENCY.POST_ORDERS_UPLOAD,
    method: 'post',
    axiosConfig: {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  });

  const requestOrdersUpload = async (
    params: TypePostOrdersUploadParams,
    {
      onSuccess,
      onError,
    }: {
      onSuccess?: (data: TypePostOrdersUploadResponse['data']) => void;
      onError?: (error: TypeErrorResponseData['error']) => void;
    }
  ) => {
    runAsync(() => postOrdersUpload({ params }), {
      onSuccess: ({ data }) => onSuccess?.(data),
      onError: (error: TypeErrorResponseData['error']) => onError?.(error),
    });
  };

  return { requestOrdersUpload };
};

export default usePostOrdersUpload;
